// import { getCallBackURL } from '../../environments/environment.feature';
import { environment } from '../../environments/environment';

/**
 * Interface for Auth0 configuration data
 * https://auth0.com/docs/quickstart/spa/angular2
 */
interface AuthConfig {
  /**
   * Auth0 clientID
   */
  clientID: string;
  /**
   * Auth0 Domain
   */
  domain: string;
  /**
   * Auth0 callback URL
   */
  callbackURL: string;
}

export interface AuthToken {
  sub: string;
  email: string;
  'https://quantummaps.com/app_metadata': {
    ui_rights: string[],
    tri_tenant: string,
    tenant_id: number,
    write_rights: string[],
    read_rights: string[],
    tenant_key: string,
  };
}

export interface AuthResult {
  accessToken?: string;
  idToken?: string;
  expiresIn?: number;
}

/**
 * Default Auth0 configuration options
 * @type {{clientID: string; domain: string; tokenName: string; callbackURL: string}}
 */
export const AUTH_CONFIG: AuthConfig = {
  clientID: getClientID(),
  domain: getDomain(),
  callbackURL: environment.callbackURL
};

function getClientID(): string {
  if (window.location.href.includes('localhost') || window.location.href.includes('mipro')) {
    return '9xUu3oS8Uzryg82VpLx0uGQjyJBP1KrK';
  } else {
    return 'yP1pcSrvE1H8KrIl9HwMideV8r79QOCp';
  }
}

function getDomain(): string {
  if (window.location.href.includes('localhost') || window.location.href.includes('mipro')) {
    return 'mic.eu.auth0.com';
  } else {
    return 'quantummaps.eu.auth0.com';
  }
}
